var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var ShareBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var shareStore = store.shareStore, commonStore = store.commonStore, createWOStore = store.createWOStore;
    var init = function () {
        shareStore.getClientId();
        shareStore.isAutoScheduleRegion();
        createWOStore.getisLastVersionAutoSchedule();
        commonStore.getAppPromotionFeatureToggle();
    };
    var dispatchConnect = {
        initShareData: init,
        getClientId: shareStore.getClientId,
        isAutoScheduleRegion: shareStore.isAutoScheduleRegion,
        getClientCode: function () { return commonStore.getClientCode(); },
        logoClickLog: commonStore.logoClickLog,
        getClientInfoByDomain: commonStore.getClientInfoByDomain
    };
    return __assign({}, dispatchConnect);
};
